import React from 'react';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { MarginProps } from '../../../../theme/styledProps';

interface Props extends MarginProps {
  icon: React.ReactNode;
  children: React.ReactNode;
}

export const SectionHeading = ({ children, icon, ...rest }: Props) => {
  return (
    <Text textAlign="center" pt="24" {...rest}>
      {icon}

      <Text as="h2" fontSize="h3" fontWeight={600} mt="8">
        {children}
      </Text>
    </Text>
  );
};
